import React from "react";
import { Navigate } from "react-router-dom";
import { useAuthChauffeur } from "./auth";

export const ProtectedDriverRoute = ({ children }) => {
  const { isAuthDrive } = useAuthChauffeur();

  if (!isAuthDrive) {
    return <Navigate to="/chauffeur/login" replace />;
  }

  return children;
};